<template>
    <div style="background-color: white;color: black;">
        <mt-header title="預約申請審核"></mt-header>
        <h2 style="color: black;padding: 10px;">預約申請審核</h2>
        <div style="padding: 15px;font-size: 16px;">
            <div style="margin-bottom: 10px;">
                <span>{{ov.partnerName}}  已提交了一份預約申請。</span>
            </div>
            <div  style="margin-bottom: 10px;">被保人姓名: <span style="color: red;">{{ov.insuredNameChi}}</span></div>
            <div style="margin-bottom: 10px;">持有人姓名: <span style="color: red;" v-if="ov.insuredAsOwner==0">{{ov.insuredNameChi}}</span>
                <span style="color: red;" v-else>{{ov.ownerNameChi}}</span>
            </div>
            <div style="margin-bottom: 10px;">保險公司: <span style="color: red;">{{ov.insuranceName}}</span></div>
            <div style="margin-bottom: 10px;">計劃: <span style="color: red;">{{ov.productOption[0].nameEng}}</span></div>
            <div style="margin-bottom: 10px;">年期: <span style="color: red;">{{getProductPeriod(ov.periodId)}}</span></div>
            <div style="margin-bottom: 10px;">認證時間: <span style="color:red;">{{ov.mcvDate*1000 | date('%Y-%m-%d')}}  {{ov.mcvTime}}</span></div>
            <div style="margin-bottom: 10px;">謝謝!</div>
        </div>


    </div>
</template>

<script>
    import "mint-ui/lib/style.css";
    import { Header } from 'mint-ui';
    import {wechatOverseaApply} from '../../api/api'

    export default {
        data() {
            //驗證登錄名字
            return {
                ov:{}
            }
        },
        methods: {
            getProductPeriod(val){
                if(val!=null && val!='' && val!=undefined){
                    return this.ov.productPeriodOption.find(v=>v.id==val).periodName;
                }
            },
            wechatOverseaApply(){
                    let params={id:this.$route.query.id};
                    return wechatOverseaApply(params).then(res=>{
                        if(res.errcode==200){
                           this.ov=res.data;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("wechatOverseaApply Error");
                    });
                }
        },
        mounted() {
            this.wechatOverseaApply();
        },
        computed: {

        },
        activated(){

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/wechat/OverseaApply.vue